(() => {
  const initialize = () => {
    document.querySelectorAll('[data-house-groups]').forEach(root => {
      if (root.dataset.houseGroupsReady) return;
      root.dataset.houseGroupsReady = 'true';
      const buttons = root.querySelectorAll('[data-house-group-select]');
      const sections = root.querySelectorAll('[data-house-group]');
      buttons.forEach(button => button.addEventListener('click', () => {
        const selected = button.dataset.houseGroupSelect;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        sections.forEach(section => { section.hidden = selected !== 'all' && section.dataset.houseGroup !== selected; });
        root.querySelector('.rnl-house-group-status').textContent = button.textContent.trim();
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
